/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Placewebpublish2Inputs */

const en_placewebpublish2 = /** @type {(inputs: Placewebpublish2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Looks right, publish`)
};

const de_placewebpublish2 = /** @type {(inputs: Placewebpublish2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passt, veröffentlichen`)
};

/**
* | output |
* | --- |
* | "Looks right, publish" |
*
* @param {Placewebpublish2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const placewebpublish2 = /** @type {((inputs?: Placewebpublish2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Placewebpublish2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_placewebpublish2(inputs)
	return de_placewebpublish2(inputs)
});
export { placewebpublish2 as "placeWebPublish" }